/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Cut_TargetInputs */

const en_portal_goal_cut_target = /** @type {(inputs: Portal_Goal_Cut_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−0.5 kg a week, no starving`)
};

const pl_portal_goal_cut_target = /** @type {(inputs: Portal_Goal_Cut_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`−0,5 kg tygodniowo, bez głodówki`)
};

/**
* | output |
* | --- |
* | "−0.5 kg a week, no starving" |
*
* @param {Portal_Goal_Cut_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_cut_target = /** @type {((inputs?: Portal_Goal_Cut_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Cut_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_cut_target(inputs)
	return en_portal_goal_cut_target(inputs)
});